export default __webpack_public_path__ + "static/image-11-f8c2ce963020041fdafbd884fda329a6.jpg";